var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-modal',{attrs:{"name":_vm.modalName,"body":_vm.body,"title":_vm.title,"ok-title":_vm.okTitle,"ok-only":""},on:{"ok":_vm.closeModal,"closed":_vm.onModalClose}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }